export const ScreenKeys = Object.freeze({
  IS_SCREEN_SMALL: 'isScreenSmall',
  CURRENT_SCREEN_WIDTH: 'CURRENT_SCREEN_WIDTH',
  CURRENT_SCREEN_HEIGHT: 'CURRENT_SCREEN_HEIGHT',
} as const);

export const ScreenThresholds = Object.freeze({
  SCREEN_RESIZE_DEBOUNCE: 1000, // milliseconds
  RIGHTRAIL_MIN_SCREEN_HEIGHT: 790, // pixels
  RIGHTRAIL_MIN_SCREEN_WIDTH: 1279, // pixels
} as const);

export const ScreenActions = Object.freeze({
  SET_SMALL_SCREEN_UI: 'SET_SMALL_SCREEN_UI',
  SET_CURRENT_SCREEN_DIMENSIONS: 'SET_CURRENT_SCREEN_DIMENSIONS',
} as const);
